module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-legend-wrapper"
  }, [_c('p', {
    staticClass: "color-legend-title"
  }, [_vm._v("Potential Vulnerability")]), _vm._v(" "), _c('div', {
    staticClass: "color-legend",
    class: _vm.orientation
  }, [_c('div', {
    staticClass: "color-label left-label"
  }, [_vm._v("Low")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "color-label right-label"
  }, [_vm._v("High")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-row"
  }, [_c('div', {
    staticClass: "legend-color-block one"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-row"
  }, [_c('div', {
    staticClass: "legend-color-block two"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-row"
  }, [_c('div', {
    staticClass: "legend-color-block three"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("3")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-row"
  }, [_c('div', {
    staticClass: "legend-color-block four"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("4")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-row"
  }, [_c('div', {
    staticClass: "legend-color-block five"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("5")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-row"
  }, [_c('div', {
    staticClass: "legend-color-block six"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("6")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2590e15a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/color-legend/ColorLegend.vue
// module id = 529
// module chunks = 1